import { combineReducers } from "redux";
import auth from "./auth/reducer";
import userReducer from "./usuario/reducer";
import showLoading from "./loading/reducer";
export default combineReducers({
  auth,
  userReducer,
  showLoading,
});
